import { render, staticRenderFns } from "./delegationEventMedalTally.vue?vue&type=template&id=69d61bbf&scoped=true"
import script from "./delegationEventMedalTally.vue?vue&type=script&lang=js"
export * from "./delegationEventMedalTally.vue?vue&type=script&lang=js"
import style0 from "./delegationEventMedalTally.vue?vue&type=style&index=0&id=69d61bbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d61bbf",
  null
  
)

export default component.exports